module.exports = __webpack_public_path__ + "img/introductionBackground.92ba4cab.png";